export const REQUEST_USER_LOGIN = 'REQUEST_USER_LOGIN';
export const RECEIVE_USER_LOGIN = 'RECEIVE_USER_LOGIN';
export const FAILED_USER_LOGIN = 'FAILED_USER_LOGIN';

export const RESTORE_USER_LOGIN = 'RESTORE_USER_LOGIN';
export const RESTORE_USER_LOGIN_FAILED = 'RESTORE_USER_LOGIN_FAILED';
export const RESTORE_USER_LOGIN_STARTED = 'RESTORE_USER_LOGIN_STARTED';
export const REQUEST_REFRESH_TOKEN = 'REQUEST_REFRESH_TOKEN';
export const RECEIVE_REFRESH_TOKEN = 'RECEIVE_REFRESH_TOKEN';
export const FAILED_REFRESH_TOKEN = 'FAILED_REFRESH_TOKEN';

export const USER_PASSWORD_EXPIRED = 'USER_PASSWORD_EXPIRED';
export const USER_PASSWORD_CHANGED = 'USER_PASSWORD_CHANGED';
export const USER_PROFILE_IS_NOT_COMPLETED_REDIRECTED = 'USER_PROFILE_IS_NOT_COMPLETED_REDIRECTED';

export const USER_LOGOUT = 'USER_LOGOUT';

export const SESSION_EXPIRATION_WARNING = 'SESSION_EXPIRATION_WARNING';
export const START_SESSION_TIMER = 'START_SESSION_TIMER';

export const SESSION_TRANSFERED = 'SESSION_TRANSFERED';

export const ACCOUNT_SELECTED = 'ACCOUNT_SELECTED';
export const USER_PROFILE_UPDATED = 'USER_PROFILE_UPDATED';

export const REQUEST_IMPERSONATE = 'REQUEST_IMPERSONATE';
export const SUCCESS_IMPERSONATE = 'SUCCESS_IMPERSONATE';
export const FAILED_IMPERSONATE = 'FAILED_IMPERSONATE';
export const VIEW_MODE_CHANGED = 'VIEW_MODE_CHANGED';
export const SET_THEME = 'SET_THEME';
export const SET_BRANDING_TEXT = 'SET_BRANDING_TEXT';
export const SET_WEB_CONFIG = 'SET_WEB_CONFIG';
